import { HiMiniUserGroup } from "react-icons/hi2";
import { GrAnnounce } from "react-icons/gr";
import { TiDocumentText } from "react-icons/ti";
import { BsBagCheck } from "react-icons/bs";
import { IoSettingsSharp, IoWallet } from "react-icons/io5";
import { PiChatTextThin } from "react-icons/pi";
import { TbGiftCard, TbLogout, TbNotes } from "react-icons/tb";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { LiaHandHoldingUsdSolid } from "react-icons/lia";
import { CgNotes } from "react-icons/cg";
import { CgProfile } from "react-icons/cg";
import { BiWalletAlt } from "react-icons/bi";
import { IoNotificationsSharp } from "react-icons/io5";
import { MdDashboard, MdOutlineFileDownload } from "react-icons/md";
import {MdPostAdd,MdWorkOutline,MdOutlineExplore,MdOutlineAssignment,MdHelpOutline} from "react-icons/md";

import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
export const sections = [
  {
    items: [
      {
        title: "Dashboard",
        modules: "dashboard",
        icon: MdDashboard,
        href: "/dashboard",
        permission: "",
      },
      {
        title: "Download",
        modules: "download",
        icon: MdOutlineFileDownload,
        href: "/download",
        permission: "",
      },
      {
        title: "CHAT",
        modules: "chat",
        icon: PiChatTextThin,
        href: "/chat",
        permission: "chat",
      },

      {
        title: "SUB-ADMIN MANAGEMENT",
        modules: "chat",
        icon: SupervisorAccountIcon,
        href: "/sub-admin",
        permission: "sub-admin",
      },
    ],
  },
];

export const sections1 = [
  {
    items: [
      {
        title: "My Media",
        modules: "MyMedia",
        icon: IoWallet,
        href: "/media-listing",
        subRoutes: [
          { title: "Add Media", href: "/add-media" },
          { title: "View Media", href: "/view-list-media" },
        ],
        permission: "mediaManagement",
      },
    ],
  },
];

export const sections2 = [
  {
    items: [
      {
        title: "Assigned by Me",
        modules: "Work List",
        icon: TbNotes,
        href: "/work-list",
        permission: "jobManagement",
      },

      {
        title: "Assigned to Me",
        modules: "My Job List",
        icon: IoPersonRemoveOutline,
        href: "/job-list",
        permission: "jobManagement",
      },
      {
        title: "My Tickets",
        modules: "My Tickets",
        icon: MdHelpOutline,
        href: "/my-tickets",
        permission: "jobManagement",
      },
      {
        title: "COMPLETED JOB",
        modules: "COMPLETED JOB",
        icon: BsBagCheck,
        href: "/completed-job",
        permission: "jobManagement",
      },
      {
        title: "Project offered",
        modules: "Project offered",
        icon: TiDocumentText,
        href: "/project-offered",
        permission: "jobManagement",
      },

      {
        title: "PROJECT LIST",
        modules: "Project List",
        icon: CgNotes,
        href: "/project-list",
        permission: "jobManagement",
      },
      {
        title: "REVENUE & COMMISSION",
        modules: "REVENUE & COMMISSION",
        icon: LiaHandHoldingUsdSolid,
        href: "/revenue-commission",
        permission: "jobManagement",
      },
    ],
    permission: "jobManagement",
  },
];

export const sectionsOpportunities=[
  {
    items:[
      {
        title:"POST OPPORTUNITY",
        modules:"Post Opportunity",
        icon:MdPostAdd,
        href:"/post-opportunity",
        permission:"",
      },
      {
        title:"MY OPPORTUNITIES",
        modules:"My Opportunities",
        icon:MdWorkOutline,
        href:"/my-opportunities",
        subRoutes:[
          {title:"Applicants",href:"/opportunity-applicants"},
        ],
        permission:"",
      },
      {
        title:"BROWSE OPPORTUNITIES",
        modules:"Browse Opportunities",
        icon:MdOutlineExplore,
        href:"/opportunities",
        audience:"CREATOR",
        permission:"",
      },
      {
        title:"MY APPLICATIONS",
        modules:"My Applications",
        icon:MdOutlineAssignment,
        href:"/my-applications",
        audience:"CREATOR",
        permission:"",
      },
    ],
  },
];

export const sections3 = [
  {
    items: [
      {
        title: "ADVERTISEMENT",
        modules: "Advertisement",
        icon: GrAnnounce,
        href: "/advertisement",
        subRoutes: [
          {
            title: "View Advertisement",
            href: "/view-advertisement",
          },
          {
            title: "Edit Advertisement",
            href: "/edit-advertisement",
          },
        ],
      },
    ],
    permission: "advertisementManagement",
  },
];

export const sections4 = [
  {
    items: [
      {
        title: "RECEIVED PAYMENT",
        modules: "RECEVIED PAYMENT",
        icon: GrAnnounce,
        href: "/order-details",
      },
      {
        title: "PAID PAYMENT",
        modules: "PAID PAYMENT",
        icon: CgNotes,
        href: "/transaction-payment",
      },
    ],

    permission: "transactionManagement",
  },
];

export const sections5 = [
  {
    items: [
      {
        title: "VIEW PROFILE",
        modules: "View Profile",
        icon: CgProfile,
        href: "/view-profile",
        permission: "",
      },
      {
        title: "MY WALLET",
        modules: "My Wallet",
        icon: BiWalletAlt,
        href: "/my-wallet",
        permission: "",
      },
      {
        title: "NOTIFICATION",
        modules: "notification",
        icon: IoNotificationsSharp,
        href: "/notification",
        permission: "",
      },

      {
        title: "AFFILIATED MEMBERS",
        modules: "Affiliated Members",
        icon: HiMiniUserGroup,
        href: "affiliatedmembers",
        permission: "affiliateManagement",
      },

      {
        title: "REWARD",
        modules: "Reward",
        icon: TbGiftCard,
        href: "/rewards",
        permission: "",
      },
      {
        title: "SETTINGS",
        modules: "Settings",
        icon: IoSettingsSharp,
        href: "/change-password",
      },
      {
        title: "LOGOUT",
        modules: "Logout",
        icon: TbLogout,
        href: "logout",
      },
    ],
  },
];
